import { render, staticRenderFns } from "./2FA.vue?vue&type=template&id=5688c1d0&scoped=true&"
import script from "./2FA.vue?vue&type=script&lang=js&"
export * from "./2FA.vue?vue&type=script&lang=js&"
import style0 from "./2FA.vue?vue&type=style&index=0&id=5688c1d0&lang=scss&scoped=true&"
import style1 from "./2FA.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5688c1d0",
  null
  
)

export default component.exports